import React, {Component} from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import '../styles/Timeline.less';
import GoogleMap from 'google-map-react';

class Event extends Component {

    constructor() {
        super();
    }

    render() {

        let mediaContent = false;

        if (this.props.map) {
            mediaContent = (
                <GoogleMap
                    bootstrapURLKeys={{key: "AIzaSyCz9IoyOFlBbnK4OmC2oLqdizthObTfGHE"}}
                    resetBoundsOnResize={true}
                    defaultCenter={{lat: this.props.map.marker.props.lat, lng: this.props.map.marker.props.lng}}
                    defaultZoom={this.props.map.zoom}>
                    {this.props.map.marker}
                </GoogleMap>
            )
        } else if (this.props.image) {
            mediaContent = (
                <Image src={this.props.image} responsive={true} />
            )
        }

        console.log(mediaContent);

        return (
            <div className="event card no-padding">
                <header><h1>{this.props.title}</h1></header>

                <div className="body">
                    <div><i className="fp fp-calendar"></i> {this.props.date.toString()}</div>
                    <div><i className="fp fp-ticket"></i> {this.props.time}</div>
                    <div><i className="fp fp-location"></i> {this.props.time}</div>

                    <div className="description">
                        {this.props.children}
                    </div>

                    <div className="media">
                        {mediaContent}
                    </div>
                </div>
            </div>
        )

    }
}

class Timeline extends Component {

    date;

    constructor() {
        super();
        this.date = new Date();
    }

    render() {
        return (
            <div className="timeline">
                {this.props.children}
            </div>
        )
    }
}

class IconMarker extends Component {
    render() {
        return (
            <div className="marker">
                <i className={this.props.children}></i>
            </div>
        )
    }
}

Timeline.propTypes = {
    children: function (props, propName, componentName) {
        const prop = props[propName];

        let error = null;
        React.Children.forEach(prop, function (child) {
            if (child.type !== Event) {
                error = new Error('`' + componentName + '` children should be of type `Event`.');
            }
        });
        return error
    }
};

Event.propTypes = {
    title: React.PropTypes.string,
    date: React.PropTypes.object,
    time: React.PropTypes.object,
    image: React.PropTypes.string,
    map: React.PropTypes.object
};

export {Timeline, Event, IconMarker};


// WEBPACK FOOTER //
// ./src/components/Timeline.js